import { action, observable } from 'mobx';

import { AppError } from '@/services/rest/api/appError';

import RootStore from './RootStore';

type State = {
  name: string;
  error: boolean;
  message: string;
  stack: string;
};

export default class ErrorHandlerStore {
  root: RootStore;

  @observable public accessor state: State = {
    name: '',
    error: false,
    message: '',
    stack: '',
  };

  constructor(root: RootStore) {
    this.root = root;
  }

  @action.bound init() {
    window.addEventListener('error', (event) => {
      if (
        event?.filename?.startsWith('debugger://') ||
        event?.filename?.startsWith('chrome-extension://') ||
        event?.filename?.startsWith('moz-extension://')
      ) {
        return;
      }

      if (event?.filename?.startsWith(window.location.origin)) {
        this.setState({
          name: event.error.name,
          message: [event.error.message, event.error.stack].join(''),
          error: true,
          stack: event.error.stack,
        });
      }
    });
    window.addEventListener('unhandledrejection', (event) => {
      const status = event.reason?.response?.status;
      const url = event.reason?.request?.url || '';

      if (!url.includes('/auth') && status === 401) return;

      if (
        event.reason?.stack?.includes(window.location.origin) ||
        event.reason instanceof AppError
      ) {
        const state = {
          name: event.reason.name,
          message: [
            event.reason.message,
            event.reason.stack,
            JSON.stringify(event.reason.body),
          ].join(''),
          error: true,
          stack: event.reason.stack,
        };

        this.setState(state);
      }
    });
  }

  @action.bound setState(state: Partial<State>) {
    this.state = { ...this.state, ...state };
  }
}
